import {Anchor} from 'src/design/atoms/Anchor';
import {Divider} from 'src/design/atoms/Divider';
import {Group} from 'src/design/atoms/Group';
import {Text} from 'src/design/atoms/Text';
import {IconX} from '@tabler/icons-react';
import React from 'react';
import {Link} from 'react-router-dom';
import {useAppSelector} from 'src/redux/hooks';
import {OfflineStatusPill} from 'src/app/offline/OfflineStatusPill';

export interface GuidedFlowBarProps {
  exitTo: string;
  /** Shown once the inspection has loaded; omitted during the initial fetch. */
  siteName?: string;
}

/**
 * Slim top chrome bar for the guided My Inspections flow, replacing `BackBar` + breadcrumbs.
 * Owns NO margins — the page provides an identical full-bleed frame in every branch.
 */
export const GuidedFlowBar: React.FC<GuidedFlowBarProps> = ({exitTo, siteName}) => {
  const isHeadlessMode = useAppSelector(state => state.interface.isHeadlessMode);
  if (isHeadlessMode) return null;

  return (
    <Group
      gap="sm"
      py={6}
      px="lg"
      style={{
        flexShrink: 0,
        borderBottom: '1px solid var(--mantine-color-gray-2)',
      }}>
      <Anchor component={Link} to={exitTo} underline="hover" style={{display: 'inline-flex'}}>
        <Group gap={4} wrap="nowrap" align="center">
          <IconX size={16} stroke={2} color="var(--mantine-color-dark-6)" />
          <Text size="sm" fw={600} c="dark">
            Exit
          </Text>
        </Group>
      </Anchor>

      {siteName && (
        <>
          <Divider orientation="vertical" size="sm" h={20} />
          <Text size="sm" c="dimmed">
            {siteName}
          </Text>
        </>
      )}

      <OfflineStatusPill ml="auto" />
    </Group>
  );
};
